import { InfoIcon, InfoIconLg } from '@components/icons';
import {
  Tooltip,
  TooltipTrigger,
  TooltipProvider,
  TooltipContent,
} from '@/components/ui/tooltip';

interface LabelWithTooltipProps {
  label: string;
  tooltip: string;
  /** Info icon size in pixels (default 16) */
  iconSize?: number;
  /** Icon color variant: 'default' for off-black (section titles), 'muted' for grey (field labels) */
  iconVariant?: 'default' | 'muted';
  /** Additional className for the wrapper */
  className?: string;
  /** Render the label as a different element */
  children?: React.ReactNode;
}

export function LabelWithTooltip({
  label,
  tooltip,
  iconSize = 16,
  iconVariant = 'default',
  className,
  children,
}: LabelWithTooltipProps) {
  const iconColor = iconVariant === 'muted' ? 'text-grey' : 'text-off-black';
  const Icon = iconSize >= 24 ? InfoIconLg : InfoIcon;

  return (
    <TooltipProvider delayDuration={200}>
      <div className={className ?? 'flex items-center gap-2'}>
        {children ?? <span>{label}</span>}
        <Tooltip>
          <TooltipTrigger asChild>
            <button type="button" aria-label="More info" className={iconColor}>
              <Icon />
            </button>
          </TooltipTrigger>
          <TooltipContent align="start" alignOffset={-20}>
            {tooltip}
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}
